import script from "./MessageMail.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageMail.vue?vue&type=script&lang=ts&setup=true"

import "./MessageMail.vue?vue&type=style&index=0&id=27336e39&lang=scss"

const __exports__ = script;

export default __exports__